export const filterBySearch = <T extends Record<string, any>>(
  objToFilter: T,
  searchString: string | undefined,
) => {
  if (searchString === undefined) {
    return objToFilter;
  }

  if (searchString === '') {
    return objToFilter;
  }
  const lowercaseString = searchString.toLowerCase();
  const filteredEntries = Object.entries(objToFilter).filter(([key]) =>
    key.toLowerCase().includes(lowercaseString),
  );

  return Object.fromEntries(filteredEntries);
};
